var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeviceSelected = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H27C31.4183 0 35 3.58172 35 8V17.5V35L0 0Z",
  fill: "#007E92"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31 4L21.9999 13L18 9.00013",
  stroke: "white",
  strokeWidth: 0.763636,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/device-selected.4dba3d83975f936fe9a86bf8c24251b8.svg";